// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topHeader {
  padding: 0 0 20px 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.topHeader .search-filter {
  display: flex;
  align-items: center;
}
.topHeader .search-filter .kl-custom-search-container {
  display: flex;
  align-items: center;
  text-align: left;
  color: #000000;
  font-size: 13px;
  font-weight: 400;
  line-height: 1;
  letter-spacing: 0px;
  width: 100%;
}
.topHeader .search-filter .kl-custom-search-container .ant-input-group {
  width: 100% !important;
}
.topHeader .search-filter .kl-custom-search-container .ant-input-affix-wrapper {
  min-height: unset;
  padding: 2px 11px;
}
.topHeader .search-filter .kl-custom-search-container .ant-input-affix-wrapper input.ant-input {
  line-height: normal;
}
.topHeader .search-filter .kl-custom-search-container .ant-input-affix-wrapper input.ant-input::placeholder {
  color: #00000080;
  font-size: 13px;
}
.topHeader .topheader-btn {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.topHeader h2 {
  color: #000000;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  margin: 0;
  line-height: 1;
}
table {
  border: none !important;
  border-radius: 4px !important;
}
.search-form .custom-form-item .ant-row {
  display: block;
}
.search-form .custom-form-item label {
  font-size: 14px;
  height: auto;
  color: #252525;
  margin-bottom: 10px;
}
.search-form .custom-form-item .ant-select-selector {
  border-radius: 10px !important;
}
.search-form .custom-form-item .ant-select-selector input {
  padding-left: 7px !important;
}
.search-form .ant-col {
  padding-right: 0px !important;
}
.search-form .ant-col input {
  padding: 13px 0px 13px 22px;
  border-radius: 10px;
}
.search-form .btnStyling {
  height: 46px;
  border-radius: 10px;
  padding: 8px 30px;
  display: flex;
  align-items: center;
}
.search-form .btnStyling svg {
  font-size: 15px;
}
.search-form .btnStyling:hover {
  border-color: #262626 !important;
  background-color: #262626 !important;
  opacity: 1 !important;
  color: #ffffff !important;
}
.search-form .form-field-sec .form-field {
  padding-left: 10px !important;
}
.search-form .form-field-sec .parent {
  padding-left: 0px !important;
}
.bold {
  font-weight: 600 !important;
  color: #040f0f !important;
}
.emailAnchor a {
  color: #040f0f !important;
}
.custom-table-grid-view-container .custom-table-container-with-hover .ant-table-tbody tr:hover {
  cursor: pointer;
}
.custom-table-grid-view-container .custom-table-container {
  font-family: "Poppins", sans-serif;
}
.custom-table-grid-view-container .custom-table-container .ant-table-content {
  box-shadow: 5px 5px 16px 0px #edf2f7;
  width: 100%;
  overflow-x: auto;
}
.custom-table-grid-view-container .custom-table-container .ant-table-content .status-badge-col .ant-table-filter-column {
  width: 100px;
}
.custom-table-grid-view-container .custom-table-container .ant-table-content .ant-pagination .ant-table-pagination li {
  margin: 0px;
}
.custom-table-grid-view-container .custom-table-container .ant-table {
  color: #252525;
}
.custom-table-grid-view-container .custom-table-container .ant-table div.ant-table-body {
  scrollbar-width: thin;
  scrollbar-highlight-color: yellow;
  scrollbar-color: #c11b2f #f5f5f5;
}
.custom-table-grid-view-container .custom-table-container .ant-table div.ant-table-body span.tooltipStyling {
  display: inherit;
  margin-left: inherit;
  font-weight: inherit;
  font-size: inherit;
  line-height: inherit;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th {
  background-color: #fafafb;
  padding: 14px 10px;
  color: #8f8f8f;
  font-weight: 500;
  border: unset !important;
  font-size: 12px;
  text-transform: uppercase;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th::before {
  display: none;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th .ant-table-filter-column {
  justify-content: flex-start;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th span {
  font-weight: 600;
  font-size: 13px;
  color: #a3a3a3;
  flex-grow: unset;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th span.ant-checkbox-indeterminate .ant-checkbox-inner::after {
  background-color: transparent !important;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th span.ant-table-filter-trigger.active svg {
  fill: #c11b2f;
}
.custom-table-grid-view-container .custom-table-container .ant-table-thead tr th .ant-table-column-sorters {
  display: grid;
  grid-template-columns: auto 1fr;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container > .ant-table-content > table > tbody > tr > td {
  padding: 14px 10px;
  border-right: none;
  color: #606060;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0em;
  word-break: break-word;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container > .ant-table-content > table > tbody > tr > td a {
  color: #606060;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container > .ant-table-content > table > tbody > tr > td:first-child {
  padding-left: 25px !important;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container > .ant-table-content > table > tbody > tr > td:last-child {
  padding-right: 25px !important;
  border-right: 1px solid #e9e9e9;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container table thead tr:first-child th:first-child {
  padding-left: 25px !important;
}
.custom-table-grid-view-container .custom-table-container .ant-table.ant-table-bordered .ant-table-container table thead tr:first-child th:last-child {
  padding-right: 25px !important;
}
.custom-table-grid-view-container .action-btn {
  padding: 0 !important;
  box-shadow: none !important;
  height: unset !important;
  background-color: transparent !important;
}
.custom-table-grid-view-container .action-btn:hover {
  opacity: 0.5 !important;
}
.custom-table-grid-view-container .btnEdit {
  background-color: #294dc6;
}
.custom-table-grid-view-container .btnEdit:hover,
.custom-table-grid-view-container .btnEdit:focus {
  color: #ffffff;
}
.custom-table-grid-view-container .btnSucess {
  background-color: #0dc826;
}
.custom-table-grid-view-container .btnDanger {
  background-color: #c62929;
}
.custom-table-grid-view-container .btnYellow {
  background-color: #d9a923;
}
.custom-table-grid-view-container .btnDownload {
  background-color: #5e6470;
}
.custom-table-grid-view-container .nameList {
  color: #2e7de5;
}
.custom-table-grid-view-container .dangerText {
  color: #c62929;
}
.custom-table-grid-view-container .success {
  color: #0dc826;
}
.custom-table-grid-view-container .action-col button.ant-btn,
.custom-table-grid-view-container .action-col a.button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0px;
  background-color: unset;
  width: unset;
  height: unset;
  color: #c11b2f !important;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  line-height: 1;
}
.custom-table-grid-view-container .action-col button.ant-btn svg,
.custom-table-grid-view-container .action-col a.button svg {
  padding: 0px;
  border: 0px;
}
.custom-table-grid-view-container .action-col button.ant-btn:hover,
.custom-table-grid-view-container .action-col a.button:hover {
  opacity: 0.8;
}
.custom-table-grid-view-container .action-col button.ant-btn.view-icon svg path,
.custom-table-grid-view-container .action-col a.button.view-icon svg path {
  fill: #606060 !important;
}
.custom-table-grid-view-container .action-col .btnEdit {
  background-color: #c11b2f;
}
.custom-table-grid-view-container .action-col .btnDanger i.tod-refund {
  font-size: 14px;
}
.custom-table-grid-view-container .action-col button.ant-btn.textWhite {
  color: #606060 !important;
}
.custom-table-grid-view-container .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #c11b2f;
  border-color: #c11b2f;
}
.custom-table-grid-view-container :hover .ant-checkbox-checked .ant-checkbox-inner {
  background-color: #c11b2f !important;
  border-color: #c11b2f !important;
}
.custom-table-grid-view-container .ant-checkbox-disabled .ant-checkbox-inner:after {
  border-color: #ffffff !important;
}
.ant-pagination {
  margin-bottom: 0 !important;
}
.ant-pagination-total-text {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  line-height: 30px !important;
  margin-right: auto !important;
}
.ant-pagination-item a {
  transition: all 0.4s ease-in-out !important;
  background: #ffffff !important;
  color: #a3a3a3 !important;
  border-color: #c11b2f !important;
  border-radius: unset !important;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  border: unset !important;
  line-height: 33px;
}
.ant-pagination-item,
.ant-pagination-prev,
.ant-pagination-next {
  transition: all 0.4s ease-in-out !important;
  border-radius: 0 !important;
  overflow: hidden;
  border: 1px solid #edf2f7 !important;
  padding: 0;
}
.ant-pagination-prev,
.ant-pagination-next {
  background-color: #ffffff;
}
.ant-pagination-prev button,
.ant-pagination-next button {
  background-color: unset !important;
  border: unset !important;
  color: #fff !important;
}
.ant-pagination-prev button span svg,
.ant-pagination-next button span svg {
  color: #a3a3a3;
}
.ant-pagination-item-active {
  font-weight: 500;
  background: #ffffff !important;
  border-color: #c11b2f !important;
}
.ant-pagination-item-active a {
  color: #ffffff !important;
  background: #c11b2f !important;
}
.ant-pagination-item a:hover {
  background: #c11b2f !important;
  color: #ffffff !important;
}
.switch-wrapper {
  display: grid;
  grid-template-columns: auto 1fr;
  justify-content: space-around;
  align-items: center;
}
.switch-wrapper .switch-status {
  color: #c11b2f;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0px;
  text-align: right;
  margin: 0;
  line-height: 1;
  display: inline;
  transition: all 0.4s ease-in-out;
  text-align: left;
  margin-left: 8px;
}
.switch-wrapper .switch-status.false {
  color: #f1f1fa;
}
@media (min-width: 1281px) and (max-width: 1599px) {
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 12px;
  }
  table tbody tr td {
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
  table tbody tr td span svg {
    font-size: 16px;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 12px;
  }
  table tbody tr td {
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 12px;
  }
  table tbody tr td {
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
}
@media (min-width: 768px) and (max-width: 1024px) {
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 12px;
  }
  table tbody tr td {
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  table .ant-table-thead tr th {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 11px !important;
  }
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 11px;
  }
  table .ant-table-thead tr th span {
    font-size: 11px !important;
  }
  table tbody tr td {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 12px;
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  table .ant-table-thead tr th {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 12px;
  }
  table .ant-table-thead tr th .ant-table-column-sorters .ant-table-column-title,
  table .ant-table-thead tr th .ant-table-filter-column .ant-table-column-title {
    font-size: 12px;
  }
  table .ant-table-thead tr th span {
    font-size: 10px !important;
  }
  table tbody tr td {
    padding: 10px 8px;
    line-height: 1.2;
    font-size: 12px;
    font-size: 12px !important;
  }
  table tbody tr td span {
    font-size: 12px !important;
  }
  .custom-table-grid-view-container .custom-table-container .ant-table-thead tr th {
    font-size: 10px;
  }
  .topHeader .topheader-btn {
    padding-top: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/CustomComponents/CustomTable/CustomTable.less"],"names":[],"mappings":"AACA;EAEE,mBAAA;EACA,2BAAA;EACA,4BAAA;AADF;AAHA;EAMI,aAAA;EACA,mBAAA;AAAJ;AAPA;EASM,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,WAAA;AACN;AAlBA;EAmBQ,sBAAA;AAER;AArBA;EAsBQ,iBAAA;EACA,iBAAA;AAER;AAzBA;EAyBU,mBAAA;AAGV;AAFU;EACE,gBAAA;EACA,eAAA;AAIZ;AAhCA;EAmCI,aAAA;EACA,mBAAA;EACA,yBAAA;AAAJ;AArCA;EAyCI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AADJ;AAqBA;EACE,uBAAA;EACA,6BAAA;AAnBF;AAuBA;EAGM,cAAA;AAvBN;AAoBA;EAMM,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAvBN;AAcA;EAYM,8BAAA;AAvBN;AAWA;EAcQ,4BAAA;AAtBR;AAQA;EAmBI,6BAAA;AAxBJ;AAKA;EAqBM,2BAAA;EACA,mBAAA;AAvBN;AACA;EA0BI,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;AAxBJ;AANA;EAgCM,eAAA;AAvBN;AAyBI;EACE,gCAAA;EACA,oCAAA;EACA,qBAAA;EACA,yBAAA;AAvBN;AAfA;EA2CM,6BAAA;AAzBN;AAlBA;EA+CM,4BAAA;AA1BN;AA+BA;EACE,2BAAA;EACA,yBAAA;AA7BF;AAgCA;EACE,yBAAA;AA9BF;AAiCA;EAGM,eAAA;AAjCN;AA8BA;EAOI,kCAAA;AAlCJ;AA2BA;EASM,oCAAA;EACA,WAAA;EACA,gBAAA;AAjCN;AAsBA;EAcU,YAAA;AAjCV;AAmBA;EAoBY,WAAA;AApCZ;AAgBA;EA8BM,cAAA;AA3CN;AAaA;EAgCQ,qBAAA;EACA,iCAAA;EACA,gCAAA;AA1CR;AAQA;EAqCU,gBAAA;EACA,oBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oBAAA;AA1CV;AACA;EAgDU,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,yBAAA;AA9CV;AA+CU;EACE,aAAA;AA7CZ;AAXA;EA4DY,2BAAA;AA9CZ;AAdA;EAgEY,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AA/CZ;AAkDgB;EACE,wCAAA;AAhDlB;AAsDc;EAEI,aAAA;AArDlB;AA1BA;EAsFY,aAAA;EACA,+BAAA;AAzDZ;AA9BA;EAmGkB,kBAAA;EAGA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AApElB;AAxCA;EA8GoB,cAAA;AAnEpB;AAqEkB;EACE,6BAAA;AAnEpB;AAqEkB;EACE,8BAAA;EACA,+BAAA;AAnEpB;AAlDA;EAgIgB,6BAAA;AA3EhB;AArDA;EAmIgB,8BAAA;AA3EhB;AAxDA;EA8II,qBAAA;EACA,2BAAA;EACA,wBAAA;EACA,wCAAA;AAnFJ;AAoFI;EACE,uBAAA;AAlFN;AAjEA;EAuJI,yBAAA;AAnFJ;AApEA;;EA2JI,cAAA;AAnFJ;AAxEA;EA+JI,yBAAA;AApFJ;AA3EA;EAmKI,yBAAA;AArFJ;AA9EA;EAsKI,yBAAA;AArFJ;AAjFA;EA0KI,yBAAA;AAtFJ;AApFA;EA8KI,cAAA;AAvFJ;AAvFA;EAkLI,cAAA;AAxFJ;AA1FA;EAsLI,cAAA;AAzFJ;AA7FA;;EA4LM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,cAAA;AA3FN;AA5GA;;EAyMQ,YAAA;EACA,WAAA;AAzFR;AA+FM;;EACE,YAAA;AA5FR;AA8FM;;EAGM,wBAAA;AA7FZ;AAzHA;EA4OM,yBAAA;AAhHN;AAoHQ;EACE,eAAA;AAlHV;AAuHM;EACE,yBAAA;AArHR;AAlIA;EA8PM,yBAAA;EACA,qBAAA;AAzHN;AAtIA;EAqQQ,oCAAA;EACA,gCAAA;AA5HR;AAmIM;EACE,gCAAA;AAjIR;AAuIA;EACE,2BAAA;AArIF;AAwIA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,4BAAA;EACA,6BAAA;AAtIF;AAyIA;EACE,2CAAA;EACA,8BAAA;EACA,yBAAA;EACA,gCAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,wBAAA;EACA,iBAAA;AAvIF;AA0IA;;;EAGE,2CAAA;EACA,2BAAA;EACA,gBAAA;EACA,oCAAA;EACA,UAAA;AAxIF;AA2IA;;EAEE,yBAAA;AAzIF;AAuIA;;EAII,kCAAA;EACA,wBAAA;EACA,sBAAA;AAvIJ;AAiIA;;EASQ,cAAA;AAtIR;AA4IA;EACE,gBAAA;EACA,8BAAA;EACA,gCAAA;AA1IF;AAuIA;EAKI,yBAAA;EACA,8BAAA;AAzIJ;AA6IA;EACE,8BAAA;EACA,yBAAA;AA3IF;AA8IA;EACE,aAAA;EACA,+BAAA;EACA,6BAAA;EACA,mBAAA;AA5IF;AAwIA;EAMI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;AA3IJ;AA4II;EACE,cAAA;AA1IN;AAyJA;EACE;;IAOY,eAAA;EA5JZ;EAqJA;IAsBQ,0BAAA;EAxKR;EAkJA;IAiBU,0BAAA;EAhKV;EA+IA;IAmBY,eAAA;EA/JZ;AACF;AA0KA;EACE;;IAOY,eAAA;EA7KZ;EAsKA;IAmBQ,0BAAA;EAtLR;EAmKA;IAiBU,0BAAA;EAjLV;AACF;AA2LA;EACE;;IAOY,eAAA;EA9LZ;EAuLA;IAmBQ,0BAAA;EAvMR;EAoLA;IAiBU,0BAAA;EAlMV;AACF;AA4MA;EACE;;IAOY,eAAA;EA/MZ;EAwMA;IAmBQ,0BAAA;EAxNR;EAqMA;IAiBU,0BAAA;EAnNV;AACF;AA6NA;EACE;IAIQ,iBAAA;IACA,gBAAA;IACA,0BAAA;EA9NR;EAwNA;;IAUY,eAAA;EA9NZ;EAoNA;IAcU,0BAAA;EA/NV;EAiNA;IAsBQ,iBAAA;IACA,gBAAA;IACA,eAAA;IAIA,0BAAA;EAvOR;EA2MA;IA0BU,0BAAA;EAlOV;AACF;AA4OA;EACE;IAIQ,iBAAA;IACA,gBAAA;IACA,eAAA;EA7OR;EAuOA;;IAUY,eAAA;EA7OZ;EAmOA;IAcU,0BAAA;EA9OV;EAgOA;IAsBQ,iBAAA;IACA,gBAAA;IACA,eAAA;IAIA,0BAAA;EAtPR;EA0NA;IA0BU,0BAAA;EAjPV;EAyPA;IAKU,eAAA;EA3PV;EAkQA;IAEI,iBAAA;EAjQJ;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n.topHeader {\n  // background-color: @white-color;\n  padding: 0 0 20px 0;\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n  .search-filter {\n    display: flex;\n    align-items: center;\n    .kl-custom-search-container {\n      display: flex;\n      align-items: center;\n      text-align: left;\n      color: @text-color-primary;\n      font-size: 13px;\n      font-weight: 400;\n      line-height: 1;\n      letter-spacing: 0px;\n      width: 100%;\n      .ant-input-group {\n        width: 100% !important;\n      }\n      .ant-input-affix-wrapper {\n        min-height: unset;\n        padding: 2px 11px;\n        input.ant-input {\n          line-height: normal;\n          &::placeholder {\n            color: @placeholder;\n            font-size: 13px;\n          }\n        }\n      }\n    }\n  }\n  .topheader-btn {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n  }\n\n  h2 {\n    color: @black-color;\n    font-size: 20px;\n    font-weight: 600;\n    text-align: left;\n    margin: 0;\n    line-height: 1;\n  }\n  .right-header {\n    // .aside {\n    //   button {\n    //     border-radius: 50px;\n    //     font-size: 15px !important;\n    //     padding: 6px 22px;\n    //     height: 35px;\n    //     &:hover {\n    //       opacity: 0.8;\n    //     }\n    //     span {\n    //       font-weight: 600 !important;\n    //     }\n    //   }\n    // }\n  }\n}\n\ntable {\n  border: none !important;\n  border-radius: 4px !important;\n  // overflow: hidden;\n}\n\n.search-form {\n  .custom-form-item {\n    .ant-row {\n      display: block;\n    }\n    label {\n      font-size: 14px;\n      height: auto;\n      color: @sidebar-active-color;\n      margin-bottom: 10px;\n    }\n    .ant-select-selector {\n      border-radius: 10px !important;\n      input {\n        padding-left: 7px !important;\n      }\n    }\n  }\n  .ant-col {\n    padding-right: 0px !important;\n    input {\n      padding: 13px 0px 13px 22px;\n      border-radius: 10px;\n    }\n  }\n  .btnStyling {\n    height: 46px;\n    border-radius: 10px;\n    padding: 8px 30px;\n    display: flex;\n    align-items: center;\n    svg {\n      font-size: 15px;\n    }\n    &:hover {\n      border-color: @header-text-color !important;\n      background-color: @header-text-color !important;\n      opacity: 1 !important;\n      color: @white-color !important;\n    }\n  }\n  .form-field-sec {\n    .form-field {\n      padding-left: 10px !important;\n    }\n\n    .parent {\n      padding-left: 0px !important;\n    }\n  }\n}\n\n.bold {\n  font-weight: 600 !important;\n  color: @black-link !important;\n}\n\n.emailAnchor a {\n  color: @black-link !important;\n}\n\n.custom-table-grid-view-container {\n  .custom-table-container-with-hover {\n    .ant-table-tbody tr:hover {\n      cursor: pointer;\n    }\n  }\n  .custom-table-container {\n    font-family: @primary-font-family;\n    .ant-table-content {\n      box-shadow: 5px 5px 16px 0px #edf2f7;\n      width: 100%;\n      overflow-x: auto;\n      .status-badge-col {\n        .ant-table-filter-column {\n          width: 100px;\n        }\n      }\n      .ant-pagination {\n        .ant-table-pagination {\n          li {\n            margin: 0px;\n          }\n        }\n      }\n    }\n    .ant-table {\n      // border-radius: 0px !important;\n      // border-bottom-left-radius: 8px !important;\n      // border-bottom-right-radius: 8px !important;\n      // overflow: hidden;\n      color: @sidebar-active-color;\n      div.ant-table-body {\n        scrollbar-width: thin;\n        scrollbar-highlight-color: yellow;\n        scrollbar-color: @primary-color #f5f5f5;\n        span.tooltipStyling {\n          font-weight: inherit;\n          display: inherit;\n          margin-left: inherit;\n          font-weight: inherit;\n          font-size: inherit;\n          line-height: inherit;\n        }\n      }\n    }\n    .ant-table-thead > {\n      tr > {\n        th {\n          background-color: #fafafb;\n          padding: 14px 10px;\n          color: #8f8f8f;\n          font-weight: 500;\n          border: unset !important;\n          font-size: 12px;\n          text-transform: uppercase;\n          &::before {\n            display: none;\n          }\n\n          .ant-table-filter-column {\n            justify-content: flex-start;\n          }\n\n          span {\n            font-weight: 600;\n            font-size: 13px;\n            color: @light-input;\n            flex-grow: unset;\n            &.ant-checkbox-indeterminate {\n              .ant-checkbox-inner {\n                &::after {\n                  background-color: transparent !important;\n                }\n              }\n            }\n\n            &.ant-table-filter-trigger {\n              &.active {\n                svg {\n                  fill: @primary-color;\n                }\n              }\n            }\n          }\n\n          .ant-table-column-sorters {\n            display: grid;\n            grid-template-columns: auto 1fr;\n          }\n        }\n      }\n    }\n    .ant-table.ant-table-bordered > {\n      .ant-table-container {\n        > .ant-table-content {\n          > table {\n            > tbody {\n              > tr {\n                > td {\n                  padding: 14px 10px;\n                  // border-right: none;\n                  // border-bottom: 1px solid @table-border-color;\n                  border-right: none;\n                  color: #606060;\n                  font-size: 14px;\n                  font-weight: 400;\n                  line-height: 1.2;\n                  letter-spacing: 0em;\n                  word-break: break-word;\n                  a {\n                    color: #606060;\n                  }\n                  &:first-child {\n                    padding-left: 25px !important;\n                  }\n                  &:last-child {\n                    padding-right: 25px !important;\n                    border-right: 1px solid @table-border-color;\n                  }\n                }\n              }\n            }\n          }\n        }\n        table > {\n          thead > {\n            tr:first-child {\n              th:first-child {\n                padding-left: 25px !important;\n              }\n              th:last-child {\n                padding-right: 25px !important;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // global css\n  .action-btn {\n    padding: 0 !important;\n    box-shadow: none !important;\n    height: unset !important;\n    background-color: transparent !important;\n    &:hover {\n      opacity: 0.5 !important;\n    }\n  }\n  .btnEdit {\n    background-color: @edit-btn;\n  }\n  .btnEdit:hover,\n  .btnEdit:focus {\n    color: @white-color;\n  }\n\n  .btnSucess {\n    background-color: @success-Color;\n  }\n\n  .btnDanger {\n    background-color: @danger-color;\n  }\n  .btnYellow {\n    background-color: @yellow-Color;\n  }\n\n  .btnDownload {\n    background-color: @gray-color;\n  }\n\n  .nameList {\n    color: @custom-link-color;\n  }\n\n  .dangerText {\n    color: @danger-color;\n  }\n\n  .success {\n    color: @success-Color;\n  }\n\n  .action-col {\n    button.ant-btn,\n    a.button {\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border: 0px;\n      background-color: unset;\n      width: unset;\n      height: unset;\n      color: @primary-color !important;\n      font-size: 16px;\n      font-weight: 500;\n      letter-spacing: 0px;\n      line-height: 1;\n      svg {\n        padding: 0px;\n        border: 0px;\n        // font-size: 16px;\n        // height: 16px;\n        // width: 16px;\n        // margin-right: 1px;\n      }\n      &:hover {\n        opacity: 0.8;\n      }\n      &.view-icon {\n        svg {\n          path {\n            fill: @grey-input !important;\n          }\n        }\n      }\n      // &.edit-icon {\n      //   // background-color: #e1f6ee;\n      //   svg {\n      //     path {\n      //       fill: #37c772 !important;\n      //     }\n      //   }\n      // }\n      // &.trash-icon {\n      //   // background-color: #fce5e4;\n      //   svg {\n      //     path {\n      //       fill: #ad0c17 !important;\n      //     }\n      //   }\n      // }\n    }\n    .btnEdit {\n      background-color: @primary-color;\n    }\n    .btnDanger {\n      i {\n        &.tod-refund {\n          font-size: 14px;\n        }\n      }\n    }\n    button.ant-btn {\n      &.textWhite {\n        color: @grey-input !important;\n      }\n    }\n  }\n\n  .ant-checkbox-checked {\n    .ant-checkbox-inner {\n      background-color: @primary-color;\n      border-color: @primary-color;\n    }\n  }\n  :hover {\n    .ant-checkbox-checked {\n      .ant-checkbox-inner {\n        background-color: @primary-color !important;\n        border-color: @primary-color !important;\n      }\n    }\n  }\n\n  .ant-checkbox-disabled {\n    .ant-checkbox-inner {\n      &:after {\n        border-color: rgb(255 255 255) !important;\n      }\n    }\n  }\n}\n\n.ant-pagination {\n  margin-bottom: 0 !important;\n}\n\n.ant-pagination-total-text {\n  font-size: 16px;\n  font-weight: 400;\n  letter-spacing: 0px;\n  text-align: left;\n  color: @text-color-primary;\n  line-height: 30px !important;\n  margin-right: auto !important;\n}\n\n.ant-pagination-item a {\n  transition: all 0.4s ease-in-out !important;\n  background: @white-color !important;\n  color: @light-input !important;\n  border-color: @primary-color !important;\n  border-radius: unset !important;\n  font-size: 14px;\n  font-weight: 400;\n  text-align: center;\n  border: unset !important;\n  line-height: 33px;\n}\n\n.ant-pagination-item,\n.ant-pagination-prev,\n.ant-pagination-next {\n  transition: all 0.4s ease-in-out !important;\n  border-radius: 0 !important;\n  overflow: hidden;\n  border: 1px solid #edf2f7 !important;\n  padding: 0;\n}\n\n.ant-pagination-prev,\n.ant-pagination-next {\n  background-color: @white-color;\n  button {\n    background-color: unset !important;\n    border: unset !important;\n    color: #fff !important;\n    span {\n      svg {\n        color: @light-input;\n      }\n    }\n  }\n}\n\n.ant-pagination-item-active {\n  font-weight: 500;\n  background: @white-color !important;\n  border-color: @primary-color !important;\n  a {\n    color: @white-color !important;\n    background: @primary-color !important;\n  }\n}\n\n.ant-pagination-item a:hover {\n  background: @primary-color !important;\n  color: @white-color !important;\n}\n\n.switch-wrapper {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  justify-content: space-around;\n  align-items: center;\n  .switch-status {\n    color: @primary-color;\n    font-size: 16px;\n    font-weight: 500;\n    letter-spacing: 0px;\n    text-align: right;\n    margin: 0;\n    line-height: 1;\n    display: inline;\n    transition: all 0.4s ease-in-out;\n    text-align: left;\n    margin-left: 8px;\n    &.false {\n      color: @form-border-color;\n    }\n  }\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          span {\n            font-size: 12px !important;\n            svg {\n              font-size: 16px;\n            }\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          span {\n            font-size: 12px !important;\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          span {\n            font-size: 12px !important;\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          span {\n            font-size: 12px !important;\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n// ##Device = Low Resolution Tablets, Mobiles (Landscape)\n// ##Screen = B/w 481px to 767px\n@media (min-width: 481px) and (max-width: 767px) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          padding: 10px 8px;\n          line-height: 1.2;\n          font-size: 11px !important;\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 11px;\n            }\n          }\n          span {\n            font-size: 11px !important;\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          padding: 10px 8px;\n          line-height: 1.2;\n          font-size: 12px;\n          span {\n            font-size: 12px !important;\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n} //  481px to 767px (Landscape) Dont delete this bracket!\n\n// ##Device = Most of the Smartphones Mobiles (Portrait)\n// ##Screen = B/w 280px to 480px\n@media (min-width: 280px) and (max-width: 480px) {\n  table {\n    .ant-table-thead {\n      tr {\n        th {\n          padding: 10px 8px;\n          line-height: 1.2;\n          font-size: 12px;\n          .ant-table-column-sorters,\n          .ant-table-filter-column {\n            .ant-table-column-title {\n              font-size: 12px;\n            }\n          }\n          span {\n            font-size: 10px !important;\n          }\n        }\n      }\n    }\n    tbody {\n      tr {\n        td {\n          padding: 10px 8px;\n          line-height: 1.2;\n          font-size: 12px;\n          span {\n            font-size: 12px !important;\n          }\n          font-size: 12px !important;\n        }\n      }\n    }\n  }\n\n  .custom-table-grid-view-container {\n    .custom-table-container {\n      .ant-table-thead > {\n        tr > {\n          th {\n            font-size: 10px;\n          }\n        }\n      }\n    }\n  }\n\n  .topHeader {\n    .topheader-btn {\n      padding-top: 15px;\n    }\n  }\n} //  280px to 480px (Portrait) Dont delete this bracket!\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
